import StorageFactory from 'static/script/app/data/storage-factory';

function ResultSet(result) {
    this._result = result;

    this._result.orderByTimestamp = this.orderByTimestamp.bind(this);
    this._result.orderByValue = this.orderByValue.bind(this);
    this._result.orderByExpire = this.orderByExpire.bind(this);

    return this._result;
}

ResultSet.prototype._orderBy = function(orderProp) {
    function orderByProp(a, b) {
        if (a[orderProp] === b[orderProp]) {
            return 0;
        }

        return a[orderProp] < b[orderProp] ? 1 : -1;
    }

    return this._result.sort(orderByProp);
};

ResultSet.prototype.orderByTimestamp = function() {
    return this._orderBy('timestamp');
};

ResultSet.prototype.orderByValue = function() {
    return this._orderBy('value');
};

ResultSet.prototype.orderByExpire = function() {
    return this._orderBy('expires');
};

function Storage(namespace, options) {
    let prop,
        attr = {
            datastore: null
        };

    for (prop in options) {
        if (options.hasOwnProperty(prop)) {
            attr[prop] = options[prop];
        }
    }

    if (!attr.datastore) {
        attr.datastore = StorageFactory.local();
    }

    this.namespace = namespace || 'default';
    this.datastore = attr.datastore;
}

Storage.prototype.getDataSafe = function() {
    try {
        return JSON.parse(this.datastore.get(this.namespace) || '{}');
    } catch (error) {
        return {};
    }
};

Storage.prototype.store = function(data) {
    this.datastore.set(this.namespace, JSON.stringify(data));
    return true;
};

Storage.prototype.remove = function(key) {
    let data = this.getDataSafe(),
        encodedKey = encodeURI(key).toLowerCase();

    this.purge(encodedKey, data);
};

Storage.prototype.purge = function(key, data) {
    delete data[key];
    this.store(data);
    return true;
};

Storage.prototype.get = function(key) {
    let data = this.getDataSafe(),
        encodedKey = encodeURI(key).toLowerCase();

    if (
        data[encodedKey] &&
        data[encodedKey].expires &&
        data[encodedKey].expires < new Date().getTime()
    ) {
        this.purge(encodedKey, data);
    }

    return (data[encodedKey] && data[encodedKey].value) || null;
};

Storage.prototype.set = function(key, value, expires, timestamp) {
    let data = this.getDataSafe(),
        encodedKey = encodeURI(key).toLowerCase();

    data[encodedKey] = {
        expires: (expires && expires.getTime()) || null,
        timestamp: (timestamp && timestamp.getTime()) || new Date().getTime(),
        value: value
    };

    this.datastore.set(this.namespace, JSON.stringify(data));

    return data[encodedKey] || null;
};

Storage.prototype.removeExpired = function() {
    let data = this.getDataSafe(),
        prop;

    for (prop in data) {
        if (data.hasOwnProperty(prop)) {
            if (
                data[prop].expires &&
                data[prop].expires < new Date().getTime()
            ) {
                this.purge(prop, data);
            }
        }
    }
};

Storage.prototype.fetch = function() {
    function addRow(row, prop, propValue) {
        row.key = decodeURI(prop);
        row.value = propValue.value;
        row.timestamp = propValue.timestamp;
        return row;
    }

    let data = this.getDataSafe(),
        rows = [],
        prop;

    for (prop in data) {
        if (data.hasOwnProperty(prop)) {
            rows.push(addRow({}, prop, data[prop]));
        }
    }

    return new ResultSet(rows);
};

Storage.prototype.flush = function() {
    return this.datastore.clear();
};

export default Storage;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/storage-service.js